const HEADSET_OUTPUT_KEYWORDS = [
  'headphone',
  'headset',
  'earphone',
  'earbuds',
  'airpods',
  'buds',
  '이어폰',
  '헤드폰',
  '헤드셋',
];

const SPEAKER_OUTPUT_KEYWORDS = [
  'speaker',
  'speakers',
  'display audio',
  'hdmi',
  'monitor',
  '스피커',
];

export const ECHO_RISK_MAX_SPEAKER_VOLUME = 65;

function normalizeLabel(label?: string): string {
  return (label ?? '').trim().toLowerCase();
}

function hasAnyKeyword(label: string, keywords: string[]): boolean {
  return keywords.some((keyword) => label.includes(keyword));
}

export function resolveSelectedAudioDevice(
  devices: MediaDeviceInfo[],
  selectedDeviceId: string,
): MediaDeviceInfo | undefined {
  if (!devices.length) return undefined;

  if (selectedDeviceId) {
    const selected = devices.find((device) => device.deviceId === selectedDeviceId);
    if (selected) return selected;
  }

  return devices.find((device) => device.deviceId === 'default') ?? devices[0];
}

export function isEchoRiskDevicePair(
  audioInputDevice?: MediaDeviceInfo,
  audioOutputDevice?: MediaDeviceInfo,
): boolean {
  if (!audioInputDevice || !audioOutputDevice) return false;

  const outputLabel = normalizeLabel(audioOutputDevice.label);
  if (!outputLabel) return false;

  if (hasAnyKeyword(outputLabel, HEADSET_OUTPUT_KEYWORDS)) return false;

  const samePhysicalGroup = Boolean(
    audioInputDevice.groupId
    && audioOutputDevice.groupId
    && audioInputDevice.groupId === audioOutputDevice.groupId,
  );

  if (hasAnyKeyword(outputLabel, SPEAKER_OUTPUT_KEYWORDS)) return true;
  if (!samePhysicalGroup) return true;

  return false;
}